import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import TabSwitcher from "component/ui/Tabs";
import DateAndTimePicker from "../../../component/ui/Datepicker";
import Input from "component/ui/Input";
import PurchasedSlot from "./purchasedSlot";
import SoldSlot from "./soldSlot";
import { useDispatch, useSelector } from "react-redux";
import { getBookingList } from "store/slice/booking";
import PageHeading from "component/ui/PageHeading";
import PageContainer from "component/ui/PageContainer";
import { getMaxValue } from "helper/appConstant";
import Button from "component/ui/Button";
import BookingDetailsDialog from "./bookingDetailsDialog";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";

const BookingHistory = () => {
  const [booking, setBooking] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [filterData, setFilterData] = useState({});
  const { bookingListData } = useSelector((state) => state.booking);
  const [bookingDetails, setBookingDetails] = useState(null);
  const Booking = [
    {
      id: 1,
      title: "Purchased",
      color: "bg-gradient-to-t from-[#F178B0] to-[#DB0C6E]",
      icon: <FaStar color="orange" size={25} />,
      border: booking == 1,
      onClick: () => {
        navigate("/booking-history?type=purchase");
        setBooking(1);
      },
    },
    {
      id: 2,
      title: "Sold",
      color: "bg-gradient-to-t from-[#B2BBFF] to-[#2BACE2]",
      icon: <FaStar color="orange" size={25} />,
      border: booking == 2,
      onClick: () => {
        navigate("/booking-history?type=sold");
        setBooking(2);
      },
    },
  ];

  useEffect(() => {
    if (type == "sold") {
      setBooking(2);
    }
  }, [type]);
  useEffect(() => {
    fetchBookingHistory();
  }, []);
  useEffect(() => {
    // if (booking == 2) {
    fetchBookingHistory();
    // }
  }, [booking]);
  // fetch booking history list
  const fetchBookingHistory = (page, buyerName, startDate, endDate) => {
    const request = {
      language: "en",
      type: booking,
      page: page ?? 1,
      perPage: 12,
      startDate: startDate
        ? moment(startDate)?.format("YYYY-MM-DD")
        : filterData?.startDate
          ? moment(filterData?.startDate)?.format("YYYY-MM-DD")
          : "",
      endDate: endDate
        ? moment(endDate)?.format("YYYY-MM-DD")
        : filterData?.endDate
          ? moment(filterData?.endDate)?.format("YYYY-MM-DD")
          : "",
      buyerName: buyerName ? buyerName : filterData?.buyerName ?? null,
      sellerName: null,
      listType: [2, 3],
    };
    dispatch(getBookingList(request));
  };

  return (
    <PageContainer>
      <PageHeading title={"Booking History"} />

      <div className="bg-white rounded-md my-4">
        <TabSwitcher tabs={Booking} />

        {booking === 1 && (
          <div className="pt-4 border-t border-gray-200 md:px-6 px-3">
            <div className="md:mb-8 mb-4">
              <h1 className="md:text-2xl text-xl font-semibold text-gray-800">
                Purchased Bookings
              </h1>
              <p className="md:text-md text-sm text-gray-600">
                View all venue bookings and reservation details
              </p>
            </div>

            {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
              <DateAndTimePicker
                showDate
                showTime={false}
                dateLabel="Start Date"
                placeholder="Enter start date"
                isRequired
                inputClassName="w-full"
              />

              <DateAndTimePicker
                showDate
                showTime={false}
                dateLabel="End Date"
                placeholder="Enter end date"
                isRequired
                inputClassName="w-full"
              />

              <div className="w-full">
                <Input label="Search History" placeholder="Search Sport" />
              </div>
            </div> */}
            <PurchasedSlot bookingListData={bookingListData}
              setBookingDetails={setBookingDetails} />
          </div>
        )}

        {booking === 2 && (
          <div className="md:px-6 px-3 my-4">
            <h2 className="text-xl font-semibold md:mb-8 mb-4">Sold History</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
              <DateAndTimePicker
                showDate
                showTime={false}
                selectedDate={filterData?.startDate}
                onDateChange={(value) => {
                  setFilterData((filter) => ({
                    ...filter,
                    startDate: value,
                  }));
                  fetchBookingHistory(null, null, value);
                }}
                dateLabel="Start Date"
                placeholder="Enter start date"
                isRequired
                inputClassName="w-full"
              />

              <DateAndTimePicker
                showDate
                showTime={false}
                selectedDate={filterData?.endDate}
                onDateChange={(value) => {
                  setFilterData((filter) => ({
                    ...filter,
                    endDate: value,
                  }));
                  fetchBookingHistory(null, null, null, value);
                }}
                dateLabel="End Date"
                placeholder="Enter end date"
                isRequired
                inputClassName="w-full"
              />

              <div className="w-full">
                <Input
                  onChange={(value) => {
                    setFilterData((filter) => ({
                      ...filter,
                      buyerName: value,
                    }));
                    fetchBookingHistory(null, value);
                  }}
                  label="Search"
                  placeholder="Search by name"
                />
              </div>
            </div>
            <div className="pb-5">
              {bookingListData?.data?.length > 0 ? (
                <SoldSlot
                  data={bookingListData?.data}
                  setBookingDetails={setBookingDetails}
                />
              ) : (
                <div className="h-[40vh] w-full flex justify-center items-center">
                  No Data found
                </div>
              )}
            </div>
            {bookingListData?.total > bookingListData?.data?.length && (
              <div className="flex justify-center py-3">
                <Button
                  children={"View More"}
                  onClick={() => {
                    fetchBookingHistory(
                      getMaxValue(bookingListData?.data?.length, 12) + 1
                    );
                  }}
                />
              </div>
            )}
          </div>
        )}
        {/* Booking details dialogs */}
        <BookingDetailsDialog
          open={bookingDetails ? true : false}
          data={bookingDetails}
          fetchBookingHistory={fetchBookingHistory}
          closeDialog={() => setBookingDetails(null)}
        />
      </div>
    </PageContainer>
  );
};

export default BookingHistory;
